import { render, staticRenderFns } from "./form_submission_confirmation.vue?vue&type=template&id=a5244904"
import script from "./form_submission_confirmation.vue?vue&type=script&lang=js"
export * from "./form_submission_confirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports